export const getObjectNestedProperties = (
  obj: any,
  propertyValueMap: Record<string, any>,
  defaultPropertyPath?: string
): Record<string, any> => {
  const result: Record<string, any> = { ...propertyValueMap };

  const getValueFromPath = (path: string, obj: any) => {
    return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
  };

  for (const key in propertyValueMap) {
    if (propertyValueMap.hasOwnProperty(key)) {
      const sourceValue = getValueFromPath(defaultPropertyPath || key, obj);
      if (sourceValue !== undefined && typeof sourceValue !== 'object') {
        result[key] = sourceValue;
      } else if (sourceValue !== undefined && typeof sourceValue === 'object' && key in sourceValue) {
        result[key] = sourceValue[key];
      }
    }
  }

  return result;
};
